__turbopack_context__.v({
  "buyComponentContainer": "EtnjsG_buyComponentContainer",
  "notAvailableSection": "EtnjsG_notAvailableSection",
  "primaryLink": "EtnjsG_primaryLink",
});
